import axios from 'axios'
import { TIME_ATTENDANCE_API_URL, APPLICATION_NAME } from '../config/config'

export default {
    Authenticate: (username, password) =>
        axios.post(TIME_ATTENDANCE_API_URL + '/api/2/passport/Authenticate', {}, { headers: { 'username': username, 'password': password, 'application_name' : APPLICATION_NAME } }).then(response => response.data)
}